export enum AuthUserRole {
    User = "user",
    Admin = "admin",
    HRReviewer = "hr_reviewer",
    EHSReviewer = "ehs_reviewer"
}
